import { rootApi } from 'root-api'

const SCHEDULING_ASSISTANT_SETINGS_PREFIX = 'ai_exec_assistant'

export const SCHEDULING_ASSISTANT_ENABLED_SETTING_NAME = `${SCHEDULING_ASSISTANT_SETINGS_PREFIX}_enabled`
export const SCHEDULING_ASSISTANT_ENABLED_SETTING_TYPE = 'BOOLEAN'
export const SCHEDULING_ASSISTANT_PRIMARY_EVENT_TYPE_SETTING_NAME = `${
  SCHEDULING_ASSISTANT_SETINGS_PREFIX}_primary_event_type_uuid`
export const SCHEDULING_ASSISTANT_PRIMARY_EVENT_TYPE_SETTING_TYPE = 'STRING'
export const SCHEDULING_ASSISTANT_MUTUAL_AVAILABILITY_SCOPE_SETTING_NAME = `${
  SCHEDULING_ASSISTANT_SETINGS_PREFIX}_mutual_availability_scope`
export const SCHEDULING_ASSISTANT_MUTUAL_AVAILABILITY_SCOPE_SETTING_TYPE = 'STRING'
export const SCHEDULING_ASSISTANT_EXPANDED_AVAILABILITY_WITHOUT_CONFIRMATION_SETTING_NAME = `${
  SCHEDULING_ASSISTANT_SETINGS_PREFIX}_expanded_availability_without_confirmation`
export const SCHEDULING_ASSISTANT_EXPANDED_AVAILABILITY_WITHOUT_CONFIRMATION_SETTING_TYPE = 'BOOLEAN'

/** Saved setting values for `SCHEDULING_ASSISTANT_MUTUAL_AVAILABILITY_SCOPE_SETTING_NAME` */
export const MUTUAL_AVAILABILITY_SCOPE_NONE = 'none'
export const MUTUAL_AVAILABILITY_SCOPE_ALL = 'all'
export const MUTUAL_AVAILABILITY_SCOPE_SAME_ORG = 'same_org'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    enableEmailAgent: build.mutation({
      query: () => ({
        url: '/api/email_agent/enable',
        method: 'POST'
      })
    }),
    disableEmailAgent: build.mutation({
      query: () => ({
        url: '/api/email_agent/disable',
        method: 'POST'
      })
    }),
    fetchSchedulingAssistantSettings: build.query({
      query: (userUuid) => ({ url: `/api/notetaker/settings/user/${userUuid}` }),
      transformResponse: (response) => {
        const settings = Array.isArray(response) ? response : []
        return settings.filter(
          (s) => (s.settingName || '').startsWith(SCHEDULING_ASSISTANT_SETINGS_PREFIX)
        )
      },
      providesTags: ['SchedulingAssistantSettings']
    }),
    postSchedulingAssistantSetting: build.mutation({
      query: ({ userUuid, settingName, settingValue, settingType }) => ({
        url: `/api/notetaker/settings/user/${userUuid}/${settingName}`,
        method: 'POST',
        data: { settingValue, settingType }
      }),
      invalidatesTags: ['SchedulingAssistantSettings']
    })
  }),
})

export const {
  useEnableEmailAgentMutation,
  useDisableEmailAgentMutation,
  useFetchSchedulingAssistantSettingsQuery,
  usePostSchedulingAssistantSettingMutation
} = api
